"use client"
import { isValidErrorCode } from "@/lib/utils";
import { useCallback, useEffect, useRef } from "react"
import { toast } from "react-toastify";

export function ErrorHandler() {
    const lastError = useRef<null | { date: number, code: string }>(null)

    const notify = useCallback((code: string) => {
        if (
            // its not a valid error code, or
            !isValidErrorCode(code) ||
            // The same code was casted just before
            (lastError.current && lastError.current.code === code
                && lastError.current.date + 200 > Date.now())
        ) {

            return
        }

        lastError.current = { code, date: Date.now() }
        toast(`Erreur interne. (Code ${code})`)
    }, [])

    useEffect(() => {
        window.onerror = function (message, source, lineno, colno, error) {
            if (typeof message === "string")
                notify(message)
            else {
                message.stopPropagation()
                message.preventDefault()
            }

            // Return true to prevent the default browser error handling
            return true;
        };

        process.on('unhandledRejection', notify);
        process.on("uncaughtException", notify)
        process.on("uncaughtExceptionMonitor", notify)
        process.on("uncaughtExceptionMonitor", notify)
    }, [])
    return <></>
}